import { render } from "./TopupModal.vue?vue&type=template&id=48498569&scoped=true"
import script from "./TopupModal.vue?vue&type=script&lang=js"
export * from "./TopupModal.vue?vue&type=script&lang=js"

import "./TopupModal.vue?vue&type=style&index=0&id=48498569&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48498569"]])

export default __exports__